module.exports = __webpack_public_path__ + "images/btn_cv_bu_bold_4cd11632ef835ec4f9e4da11d8f9dc95.png";